module.exports = __webpack_public_path__ + "./fonts/SF-Pro-Rounded-Semibold.otf";